import { Link, useNavigate } from "react-router-dom"
import Pagination from "../../Components/Pagination"
import { MyContext } from "../../Components/Context";
import { useContext } from "react";
import SearchField from "../../Components/Forms/SearchField";


export default function DernieresAnnonces({data}){


    const navigate = useNavigate();
    const {actifItem, setActifItem} = useContext(MyContext);
    
    

    const tableItems = [
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            position: "10 Mars 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
    ]

    return (
        <div className="">
            <p className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Dernieres Annonces</p>
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b border-gray-600 dark:text-gray-200 dark:bg-gray-800">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">Nom</th>
                            <th className="px-6 py-3">Proprio</th>
                            <th className="px-6 py-3">Date de creation</th>
                            <th className="px-6 py-3">Prix</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition bg-gray-200 border-gray-600 rounded cursor-pointer hover:bg-gray-200 duration-900 dark:text-gray-200 hover:text-gray-800 dark:bg-gray-800"
                                        onClick={()=>{
                                            navigate(`/annonce/details/${item.id}`)
                                            setActifItem('Annonces')
                                        }}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <img src={`${process.env.REACT_APP_API_PICTURE_URL}${item.picture}`} alt={'annonceAnnonce'} className="w-10 h-10 rounded-full" />
                                                <div>
                                                    <span className="block text-sm font-medium">{item.id}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.title}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.owner.client.firstname}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.price} {item.periodPrice}</td>
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}